import { defineStore } from 'pinia'
export default defineStore({
  id: 'quoteDataTable',
  persist: true,
  state: () => {
    return {
      isQuoteRequestArchive: false,
      isQuoteArchive: false
    }
  },
  actions: {
    setIsQuoteRequestArchive: function (payload: any) {
      this.isQuoteRequestArchive = payload
    },
    setIsQuoteArchive: function (payload: any) {
      this.isQuoteArchive = payload
    }
  },
  getters: {
    getIsQuoteRequestArchive: (state: any) => state.isQuoteRequestArchive,
    getIsQuoteArchive: (state: any) => state.isQuoteArchive
  }
})
